import { render, staticRenderFns } from "./ClientsList.vue?vue&type=template&id=0f0a6356&scoped=true&"
import script from "./ClientsList.vue?vue&type=script&lang=js&"
export * from "./ClientsList.vue?vue&type=script&lang=js&"
import style0 from "./ClientsList.vue?vue&type=style&index=0&id=0f0a6356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a6356",
  null
  
)

export default component.exports